import React from "react";
import { BottomBtnDiv, BottomFlexBtn, BottomFlexDiv } from "./BottomStyle";

const BottomBtn = (props) => {
  return <BottomBtnDiv onClick={() => props.event()}>{props.text}</BottomBtnDiv>;
};

export const BottomBtnDual = (props) => {
  return (
    <BottomFlexBtn color={props.color} onClick={() => props.event()}>
      {props.text}
    </BottomFlexBtn>
  );
};

export default BottomBtn;
